import * as ReactQuery from "@tanstack/react-query";
import * as Brm from "services/brm";
import { MutationOption } from "libs/react-query";

interface IExportTestGuidance {
  variantId: string;
}

/**
 *
 * @param {string} variantId - uuid of the variant
 */
const exportTestGuidance = async ({ variantId }: IExportTestGuidance) => {
  // exportTestGuidanceVariantWithHttpInfo because exportTestGuidanceVariant endpoint response is busted, possibly because it is POST instead of GET.
  const res = await Brm.variantApi.exportTestGuidanceVariantWithHttpInfo(variantId);
  return res.response.body;
};

interface IUseExportTestGuidance {
  options?: MutationOption<typeof exportTestGuidance>;
}

/**
 * Custom hook to get Test Guidance report data
 *
 * @param {string} variantId - uuid of the variant
 * @param {object} options - react-query configuration object
 * @returns react-query for exportTestGuidance
 */
export const useExportTestGuidance = ({ options }: IUseExportTestGuidance = {}) => {
  return ReactQuery.useMutation({
    ...options,
    mutationFn: exportTestGuidance,
  });
};
